"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _Banner = _interopRequireDefault(require("./Banner.theme"));

var _styles = require("./styles");

var _excluded = ["theme", "status", "title", "description", "hasCloseButton", "buttonTitle", "buttonClicked", "show", "closeButtonClicked"];

var InfoIcon = function InfoIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6 0C2.68548 0 0 2.70968 0 6C0 9.31452 2.68548 12 6 12C9.29032 12 12 9.31452 12 6C12 2.70968 9.29032 0 6 0ZM6 10.8387C3.31452 10.8387 1.16129 8.68548 1.16129 6C1.16129 3.33871 3.31452 1.16129 6 1.16129C8.66129 1.16129 10.8387 3.33871 10.8387 6C10.8387 8.68548 8.66129 10.8387 6 10.8387ZM6 2.66129C5.41935 2.66129 4.98387 3.12097 4.98387 3.67742C4.98387 4.25806 5.41935 4.69355 6 4.69355C6.55645 4.69355 7.01613 4.25806 7.01613 3.67742C7.01613 3.12097 6.55645 2.66129 6 2.66129ZM7.35484 8.80645V8.22581C7.35484 8.08065 7.20968 7.93548 7.06452 7.93548H6.77419V5.51613C6.77419 5.37097 6.62903 5.22581 6.48387 5.22581H4.93548C4.76613 5.22581 4.64516 5.37097 4.64516 5.51613V6.09677C4.64516 6.26613 4.76613 6.3871 4.93548 6.3871H5.22581V7.93548H4.93548C4.76613 7.93548 4.64516 8.08065 4.64516 8.22581V8.80645C4.64516 8.97581 4.76613 9.09677 4.93548 9.09677H7.06452C7.20968 9.09677 7.35484 8.97581 7.35484 8.80645Z"
  }));
};

InfoIcon.defaultProps = {
  viewBox: "0 0 12 12",
  fill: "#637792",
  xmlns: "http://www.w3.org/2000/svg"
};

var TimesIcon = function TimesIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.75 15.95L31.55 5.25C32.15 4.65 32.15 3.55 31.55 2.95L29.05 0.45C28.45 -0.15 27.35 -0.15 26.75 0.45L16.05 11.25L5.25 0.45C4.65 -0.15 3.55 -0.15 2.95 0.45L0.45 2.95C-0.15 3.55 -0.15 4.65 0.45 5.25L11.25 15.95L0.45 26.75C-0.15 27.35 -0.15 28.45 0.45 29.05L2.95 31.55C3.55 32.15 4.65 32.15 5.25 31.55L16.05 20.75L26.75 31.55C27.35 32.15 28.45 32.15 29.05 31.55L31.55 29.05C32.15 28.45 32.15 27.35 31.55 26.75L20.75 15.95Z"
  }));
};

TimesIcon.defaultProps = {
  viewBox: "0 0 32 32",
  fill: "black",
  xmlns: "http://www.w3.org/2000/svg"
};

var Banner = function Banner(_ref) {
  var theme = _ref.theme,
      status = _ref.status,
      title = _ref.title,
      description = _ref.description,
      hasCloseButton = _ref.hasCloseButton,
      buttonTitle = _ref.buttonTitle,
      buttonClicked = _ref.buttonClicked,
      show = _ref.show,
      closeButtonClicked = _ref.closeButtonClicked,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var bannerColors = (0, _Banner.default)(theme, status);
  return /*#__PURE__*/_react.default.createElement(_styles.Container, Object.assign({
    show: show,
    bannerColors: bannerColors
  }, rest), /*#__PURE__*/_react.default.createElement(_styles.Icon, {
    bannerColors: bannerColors
  }, /*#__PURE__*/_react.default.createElement(InfoIcon, null)), /*#__PURE__*/_react.default.createElement(_styles.Header, null, /*#__PURE__*/_react.default.createElement(_styles.HeaderTitle, null, title), /*#__PURE__*/_react.default.createElement(_styles.HeaderDescription, null, description)), /*#__PURE__*/_react.default.createElement(_styles.RightContainer, null, buttonTitle && /*#__PURE__*/_react.default.createElement(_styles.ActionButton, {
    onClick: buttonClicked
  }, buttonTitle), hasCloseButton && /*#__PURE__*/_react.default.createElement(_styles.CloseButton, {
    onClick: closeButtonClicked
  }, /*#__PURE__*/_react.default.createElement(TimesIcon, null))));
};

Banner.defaultProps = {
  show: true,
  status: 'info',
  hasCloseButton: false,
  buttonClicked: function buttonClicked() {},
  closeButtonClicked: function closeButtonClicked() {}
};

var _default = (0, _styledComponents.withTheme)(Banner);

exports.default = _default;